import React from "react";

export default function BottomSheet({ children, show, setShow, onClose, backdrop = true }) {
    if (!show) return null;

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            onClick={(e) => {
                // Close if backdrop is clicked
                if (e.target === e.currentTarget) {
                    if(onClose) onClose();
                    setShow(null);
                }
            }}
            style={{ backgroundColor: backdrop ? "rgba(0,0,0,0.5)" : "" }}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content position-relative">
                    <button
                        type="button"
                        className="btn btn-light position-absolute top-0 end-0 m-1 z-3"
                        onClick={() => {
                            if(onClose) onClose();
                            setShow(null)
                        }}
                        aria-label="Close"
                    >
                        <i className="bi bi-x-lg" style={{fontSize: "20px"}}></i>
                    </button>
                    <div className="modal-body p-4">{children}</div>
                </div>
            </div>
        </div>
    );
}
